let videoElements = document.querySelectorAll('[id^="video-"]');
videoElements.forEach(video => {
  let str = video.id;
  let lastChar = str.charAt(str.length - 1);
  // console.log("=====lastChar", lastChar);
  let video0 = document.getElementById(`video-${lastChar}`);
    let circlePlayButton0 = document.getElementById(`circle-play-b-${lastChar}`);
    // console.log("hi from custom js");
    
    function togglePlay() {
        console.log("button clicked");
    	if (video0.paused || video0.ended) {
    		video0.play();
    	} else {
    		video0.pause();
    	}
    }
    
    circlePlayButton0.addEventListener("click", togglePlay);
    video0.addEventListener("playing", function () {
    	circlePlayButton0.style.opacity = 0;
    });
    video0.addEventListener("pause", function () {
    	circlePlayButton0.style.opacity = 1;
    });
});
    